module.exports = __webpack_public_path__ + "static/media/IMG_2192.2ce711fb.jpg";